<template lang="html">
  <section class="dashboard content-wrapper">
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 grid-margin stretch-card">
        <div class="card card-statistics">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left">
                <i class="mdi mdi-receipt text-warning icon-lg"></i>
              </div>
              <div class="float-right">
                <p class="card-text text-right">{{$t('Licenses')}}</p>
                <div class="fluid-container">
                  <h3 class="card-title font-weight-bold text-right mb-0">{{$store.state.company.numberOfLicenses}}</h3>
                </div>
              </div>
            </div>
            <p class="text-muted mt-3">
              <!--<i class="mdi mdi-bookmark-outline mr-1" aria-hidden="true"></i> Product-wise sales-->
            </p>
          </div>
        </div>
      </div>
      <!--<div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 grid-margin stretch-card">-->
        <!--<div class="card card-statistics">-->
          <!--<div class="card-body">-->
            <!--<div class="clearfix">-->
              <!--<div class="float-left">-->
                <!--<i class="mdi mdi-account-location text-teal icon-lg"></i>-->
              <!--</div>-->
              <!--<div class="float-right">-->
                <!--<p class="card-text text-right">{{$t('Active Users')}}</p>-->
                <!--<div class="fluid-container">-->
                  <!--<h3 class="card-title font-weight-bold text-right mb-0">{{$store.state.company.activeLicenses}}</h3>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<p class="text-muted mt-3">-->
              <!--&lt;!&ndash;<i class="mdi mdi-calendar mr-1" aria-hidden="true"></i> Weekly Sales&ndash;&gt;-->
            <!--</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 grid-margin stretch-card">-->
        <!--<div class="card card-statistics">-->
          <!--<div class="card-body">-->
            <!--<div class="clearfix">-->
              <!--<div class="float-left">-->
                <!--<i class="mdi mdi-poll-box text-info icon-lg"></i>-->
              <!--</div>-->
              <!--<div class="float-right">-->
                <!--<p class="card-text text-right">{{$t('Labels')}}</p>-->
                <!--<div class="fluid-container">-->
                  <!--<h3 class="card-title font-weight-bold text-right mb-0">{{$t('Coming Soon')}}</h3>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<p class="text-muted mt-3">-->
              <!--&lt;!&ndash;<i class="mdi mdi-reload mr-1" aria-hidden="true"></i> Product-wise sales&ndash;&gt;-->
            <!--</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="col-12">
        <b-card v-if="['System Admin', 'Administrator'].includes($store.state.user.data.role)" class="col-md-12 no-padding"  :header="$t('Licenses Expiring in less than a Month')" header-bg-variant="light" header-text-variant="white" >
          <b-table
            show-empty
            hover
            small
            stacked="true"
            :items="licensesExpiring"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(companyName)="row">
              <b-link  class="nav-link" :to="{name: 'Licenses', params: {companyId: row.item.companyId}}">{{ row.item.companyName }} </b-link>
            </template>

            <template v-slot:cell(userName)="row">
              <b-link v-if="row.item.userId" class="nav-link" :to="'/users/'+row.item.userId">{{ row.item.userName }}</b-link>
              <label class="text-secondary" v-else> No User</label>
            </template>
            <template v-slot:cell(expiresIn)="row">
              <label class="text-danger">{{ row.item.expiresIn }}</label>
            </template>
            <template v-slot:cell(actions)="row" >
              <b-button variant="light" size="sm" @click="todo" class="mr-1 text-white">
                Send Reminder
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>
        </b-card>
<br>
        <b-card v-if="['System Admin', 'Administrator'].includes($store.state.user.data.role)" class="col-md-12 no-padding"  :header="$store.state.user.data.role === 'System Admin' ? $t('Companies Running out of labels') : $t('Licenses Expiring in the next Month', $i18n.locale)" header-bg-variant="light" header-text-variant="white" >
          <b-table
            show-empty
            hover
            small
            stacked="true"
            :items="[]"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(userName)="row">
              <b-link v-if="row.item.userId" class="nav-link" :to="'/users/'+row.item.userId">{{ row.item.userName }}</b-link>
              <label v-else> {{$t('No User')}}</label>
            </template>
            <!--<template v-slot:cell(actions)="row" >-->
              <!--<b-button variant="light" size="sm" @click="todo" class="mr-1 text-white">-->
                <!--Send Reminder-->
              <!--</b-button>-->
            <!--</template>-->
          </b-table>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import moment from 'moment'
export default {
  name: 'dashboard',
  data () {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      licensesExpiring: []
    }
  },
  watch: {
    // whenever question changes, this function will run
    companyId: function (newQuestion, oldQuestion) {
      this.getLicenses()
    }
  },
  computed: {
    companyId () {
      return this.$store.state.user.data ? this.$store.state.user.data.companyId : ''
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    fields () {
      var aFields = []
      if (this.$store.state.user.data.role === 'System Admin') {
        aFields.push({ key: 'companyName', label: this.$t('Company', this.$i18n.locale), sortable: false })
      }
      aFields.push({ key: 'userName', label: this.$t('Assigned User'), sortable: false })
      aFields.push({ key: 'expiryDate', label: this.$t('Expires On'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'expiresIn', label: this.$t('Days Remaining'), sortable: true, class: 'text-center' })

      return aFields
    }
  },
  mounted () {
    this.getLicenses()
    this.$store.dispatch('fetchCompany')
  },
  methods: {
    getLicenses () {
      let dateInMonth = moment(new Date()).add(1, 'M').toDate()
      // console.log(dateInMonth)
      let self = this
      self.licensesExpiring = []
      let query
      // console.log('this.$store.state.user.role', this.$store.state.user.data.companyId)
      if (this.$store.state.user.data.role === 'Administrator') {
        query = this.$firebase.firestore().collectionGroup('licenses').where('expiryDate', '<=', dateInMonth).where('companyId', '==', this.companyId).limit(10)
      } else {
        query = this.$firebase.firestore().collectionGroup('licenses').where('expiryDate', '<=', dateInMonth).limit(10)
      }
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
          var licenseData = doc.data()
          // console.log('licenseData', licenseData)
          licenseData.id = doc.id
          if (licenseData.expiryDate != null) {
            licenseData.expiresIn = self.expiryDate(licenseData.expiryDate)
            if (licenseData.expiresIn > 0) {
              licenseData.status = 'Active'
            } else {
              licenseData.status = 'Expired'
            }
            licenseData.expiryDate = moment(String(licenseData.expiryDate.toDate())).format('DD/MM/YYYY')
          }
          self.licensesExpiring.push(licenseData)
        })
      })
    },
    expiryDate (dateString) {
      var expiration = moment(dateString.toDate(), 'DD/MM/YYY')
      var currentDate = moment()
      return moment(expiration).diff(currentDate, 'days')
    },
    onFiltered (filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    todo () {
      alert('Demo')
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue